import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Users2, Globe2, Sparkles } from "lucide-react";
import Chapter from "../site/Chapter";

const points = [
  { icon: Users2, text: "10+ years in staffing and outsourcing operations" },
  { icon: Globe2, text: "Experience across staffing, healthcare, real estate, insurance, and eCommerce" },
  { icon: ShieldCheck, text: "US, UK & EU client coverage" },
  { icon: Sparkles, text: "Every AI output reviewed by a trained specialist, not shipped raw" },
];

export default function HomeFounder({ chapterNumber = "08" }) {
  return (
    <section
      id="about"
      data-testid="founder-section"
      className="relative py-24 sm:py-32 border-t border-slate-900 bg-[#070F1F]"
    >
      <div className="absolute inset-0 bg-radial-lime opacity-40" />
      <div className="relative max-w-[1400px] mx-auto px-6 sm:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-6">
            <Chapter
              number={chapterNumber}
              eyebrow="Who's Behind A4 Assist"
              accent="lime"
              title={
                <>
                  Built by people who've{" "}
                  <span className="font-serif italic">actually run</span>{" "}
                  this work.
                </>
              }
            />
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: 0.1 }}
              className="mt-6 space-y-4 text-base sm:text-lg text-slate-400 leading-relaxed"
            >
              <p>
                A4 Assist was founded by{" "}
                <span className="text-white">Sahil Batra</span>, who's spent
                over a decade inside recruitment and outsourcing operations —
                including senior leadership roles running delivery for staffing
                and outsourcing firms — before building A4 Assist to bring that
                same operating discipline to recruiting, business operations,
                and data work.
              </p>
              <p>
                We're not an AI software vendor and we're not a virtual-assistant
                marketplace. We're an operations partner. Our job is to turn AI
                capability into work that actually gets done, week after week.
              </p>
            </motion.div>
          </div>

          <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {points.map((p, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: i * 0.06 }}
                data-testid={`founder-point-${i}`}
                className="rounded-xl border border-slate-800 bg-[#0A1325]/70 p-6 hover:border-[#00E5FF]/40 transition-colors flex gap-4 items-start"
              >
                <div className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#00E5FF]/10 text-[#00E5FF] border border-[#00E5FF]/20">
                  <p.icon size={18} />
                </div>
                <div className="text-sm text-slate-300 leading-relaxed">
                  {p.text}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
